export const phone = new RegExp('^(62)8[1-9][0-9]{6,10}$');
export const number = new RegExp('^[0-9]+$');